export default __webpack_public_path__ + "static/media/elevate-blk-2.d52ebcf0.png";